import { not } from '@ember/object/computed';
import { assert } from '@ember/debug';
import EmberObject from '@ember/object';
import { DayOfWeek } from '@square/dashboard-data/models/hours';

// eslint-disable-next-line ember/no-classic-classes
export default EmberObject.extend({
  store: null,
  dayOfWeek: null,
  // must be from Hours.DayOfWeek
  hours: null,
  isOpen: null,
  isNotOpen: not('isOpen'),
  init() {
    this._super();
    assert("HoursPerWeekday's dayOfWeek must be an Hours.DayOfWeek.", DayOfWeek.hasValue(this.dayOfWeek));
    if (this.hours?.length === 0) {
      this.setIsOpen(false);
      this.addNewHours();
    } else {
      this.setIsOpen(true);
    }
  },
  createNewHours() {
    return this.store.createFragment('hours', {
      dayOfWeek: this.dayOfWeek,
      isPlaceholder: true
    });
  },
  addNewHours() {
    // add an empty record
    this.hours.pushObject(this.createNewHours());
  },
  removeHours(removeHours) {
    this.hours.removeObject(removeHours);
    if (!this.hours?.length) {
      this.addNewHours();
    }
  },
  setIsOpen(isOpen) {
    this.set('isOpen', isOpen);
    this.hours.setEach('disabled', !isOpen);
  }
});